var map = {
	"./bfs/app/shared/search/search-sidebar/search-sidebar.component": [
		62444,
		"src_themes_bfs_app_shared_search_search-sidebar_search-sidebar_component_ts"
	],
	"./custom/app/shared/search/search-sidebar/search-sidebar.component": [
		26318,
		"src_themes_custom_app_shared_search_search-sidebar_search-sidebar_component_ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 98587;
module.exports = webpackAsyncContext;